import { Routes } from '@angular/router';
import { meetingRoomGuard } from './guards/meeting-room.guard';
import { AuthGuard } from './guards/auth.guard';
import { mobileRedirectGuard } from './guards/mobile-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [mobileRedirectGuard],
    children: [
      {
        path: 'test',
        loadComponent: () =>
          import('./pages/page-short-link/page-short-link.component').then(
            (m) => m.PageShortLinkComponent
          ),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: '',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./layouts/layout/layout.component').then(
            (m) => m.LayoutComponent
          ),
        loadChildren: () =>
          import('./pages/pages.routing').then((m) => m.PagesRouting),
      },
      {
        path: 'meeting/:roomID',
        canActivate: [meetingRoomGuard],
        loadComponent: () =>
          import('./pages/meeting-ui/meeting-ui.component').then(
            (m) => m.MeetingUiComponent
          ),
      },
      {
        path: 'call',
        loadComponent: () =>
          import('./pages/call/call.component').then((m) => m.CallComponent),
      },
      // {
      //   path: 'download-app',
      //   loadComponent: () =>
      //     import('./pages/download-app/download-app.component').then(
      //       (m) => m.DownloadAppComponent
      //     ),
      // },
    ],
  },
];
